module.exports = __webpack_public_path__ + "img/5.de40b9fd.png";